import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];
  static values = { url: String };

  toggle(event) {
    event.preventDefault();

    const content = this.contentTarget;

    if (content.classList.contains("hidden")) {
      content.classList.remove("hidden");

      // Fetch hourly data on first open
      if (!content.dataset.loaded) {
        fetch(this.urlValue)
          .then((response) => response.text())
          .then((html) => {
            content.querySelector("td").innerHTML = html;
            content.dataset.loaded = "true";
          });
      }
    } else {
      content.classList.add("hidden");
    }
  }

  hide(event) {
    event.preventDefault();
    this.contentTarget.classList.add("hidden");
  }
}